import { useMutation, useQueryClient } from "@tanstack/react-query";
import { templateBuilderMutations } from "@/features/template-builder/mutations";
import { templateBuilderQueries } from "@/features/template-builder/queries";
import {
  normalizeOutputTypes,
  type OutputTypeEnum,
} from "@/domains/templates/output-types";
import type { StepWithSettings } from "@/domains/templates/types";

type Params = {
  id: string;
  name: string;
  description: string | null;
  outputTypes: OutputTypeEnum[];
};

export function useUpdateTemplateStep(templateId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, name, description, outputTypes }: Params) => {
      const normalizedOutputTypes = normalizeOutputTypes(outputTypes);
      return templateBuilderMutations.updateTemplateStepMetadata({
        templateId,
        stepId: id,
        display_name: name,
        display_description: description,
        display_output_types:
          normalizedOutputTypes.length > 0
            ? normalizedOutputTypes
            : ["markdown"],
      });
    },
    onSuccess: (canonicalStep) => {
      queryClient.setQueryData<StepWithSettings[]>(
        templateBuilderQueries.steps(templateId).queryKey,
        (current) =>
          current?.map((step) =>
            step.analysis_step_id === canonicalStep.analysis_step_id
              ? canonicalStep
              : step,
          ),
      );
    },
  });
}
